// @ts-nocheck
import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import Fetch from '@/utils/Fetch';
import ManagePurchaseOrder from '@/components/purchase/manage';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Router, { useRouter } from 'next/router';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router'
import DetailsPageLoader from '@/components/details-page-loader'

function EditPurchaseOrder() {
  const router = useRouter();
  const { id, tab, module, moduleID, supplierID } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  const [initTab, setInitTab] = useState<any>(null);

  const { data: purchaseOrder } = useQuery(
    ['purchaseOrder', id],
    () => Fetch.get({ url: `/PurchaseOrder/${id}` }),
    { enabled: !!id }
  );

  const { data: commentsData } = useQuery(
    ['comments', id],
    () => Fetch.post({ url: '/Comment/GetComments', params: { ItemId: id, PageIndex: 0, PageSize: 5 } }),
    { enabled: !!id }
  );

  const { data: company } = useQuery(
    ['company'],
    () => Fetch.get({ url: '/Company' })
  );

  useEffect(() => {
    const subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  useEffect(() => {
    if (initTab === null && router.isReady) {
      setInitTab(tab === 'communication' ? 'Messages' : 'Purchase');
    }
  }, [router.isReady, tab]);

  if (!purchaseOrder || !company || initTab === null) return (
    <DetailsPageLoader
      tabWidths={[80, 90, 55, 100, 120]}
      actionWidths={[90, 90, 65]}
    />
  );

  return (
    <>
      <Head><title>{purchaseOrder?.PurchaseOrderNumber} | Purchases</title></Head>
      <div>
        <ManagePurchaseOrder
          isNew={false}
          initTab={initTab}
          module={module}
          moduleID={moduleID}
          supplierID={supplierID}
          purchaseOrder={purchaseOrder}
          accessStatus={accessStatus}
          comments={commentsData?.Results}
          totalComments={commentsData?.TotalResults}
          company={company}
        />
      </div>
    </>
  );
}

export default EditPurchaseOrder;

export const Route = createFileRoute('/_authenticated/purchase/$id')({ component: EditPurchaseOrder })
